<div class="mock-interviews-header">
    <h1 tabindex="-1" [class.text-truncate]="truncateTitle">{{ title }}</h1>
    <button type="button" *ngIf="usertype !== 'manager'" class="btn btn_link btn_icn icn-close icon-size-lg no-margin flex-shrink-0" (click)="close()" [attr.aria-label]="'interviews.Close' | translate"></button>
</div>

<ng-content select="[step-content]"></ng-content>

<div class="mock-interviews-actions">
    <ng-content select="[step-actions]"></ng-content>
</div>